import script from "./JapaneseCalendarModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JapaneseCalendarModal.vue?vue&type=script&setup=true&lang=js"

import "./JapaneseCalendarModal.vue?vue&type=style&index=0&id=01bc55fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bc55fe"]])

export default __exports__